import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingColumns } from "@fortawesome/free-solid-svg-icons";
import ApplyForIbanModal from "../../Common/ApplyForIbanModal";

export default function BslApplyCard() {
  const [popupOpen, setPopupOpen] = useState(false);

  return (
    <div className="new-sidebar-bsl-apply">
      <div className="new-sidebar-bsl-apply__icon" aria-hidden="true">
        <FontAwesomeIcon icon={faBuildingColumns} />
      </div>
      <strong>Link your BSL Account</strong>
      <p>Link your BSL bank account.</p>
      <button type="button" onClick={() => setPopupOpen(true)}>
        Apply Now
      </button>

      {popupOpen ? (
        <ApplyForIbanModal
          open={popupOpen}
          onClose={() => setPopupOpen(false)}
        />
      ) : null}
    </div>
  );
}
